/** The Backstory mark. Each theme has its own artwork; CSS shows the one that matches. */
export function Logo({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <span className={className ? `logo-mark ${className}` : "logo-mark"} aria-hidden="true">
      <img className="logo-on-dark" src="/brand/logo-dark.png" width={size} height={size} alt="" />
      <img className="logo-on-light" src="/brand/logo-light.png" width={size} height={size} alt="" />
    </span>
  );
}

/** Mark plus wordmark, used in the app shell and on the auth screens. */
export function Wordmark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <>
      <Logo size={size} className={className} />
      <span>Backstory</span>
    </>
  );
}
